import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { AppRootState } from '../../../app/store';
import { updateMeTC, updateMyPasswordTC, UserType } from '../users-reducer';
import { checkAutoLogin } from '../../Login/auth-reducer';
import { getLocation, getProjectNamesFromCookies } from '../../../app/cookies';
import { setProjectName } from '../../NewTask/newTask-reducer';
import { PasswordSettings } from '../PasswordSettings';


export const CurrentUserData = () => {
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const me = useSelector<AppRootState, UserType>(state => state.auth.me)
  const navigate = useNavigate()
  const dispatch = useDispatch()
 

  useEffect(() => {
    let token = checkAutoLogin(dispatch, false)
    if (token === null && isLoggedIn === false) {
      return navigate('/login')
    } 
    else {
      if (token !== null && isLoggedIn === false) {
        return navigate(`/`)
      }
    }
    const location = getLocation()
    setProjectName(location.projectName)
    let myProjects = me.projects.map(pr => pr.projectName)
    setMyProjects(myProjects)
  }, [isLoggedIn]);

  const [values, setValues] = useState({ ...me })

  let projectNames: Array<{ projectName: string, projectId: number }> = getProjectNamesFromCookies()
  if (!projectNames) {
    projectNames = [] as Array<{ projectName: string, projectId: number }>
  }

  const [myProjects, setMyProjects] = useState<string[]>([])

  let reqBody = {
    ...values
  }

  let isSaveButtonDisabled: boolean
  me.firstName === values.firstName && me.lastName === values.lastName && me.email === values.email
    && me.description === values.description
    ? isSaveButtonDisabled = true
    : isSaveButtonDisabled = false

  async function updateUser() {
    await dispatch(updateMeTC({ user: reqBody }))
    console.log('UPDATE USER ME: ',reqBody)
    navigate(`/me/`)
  }
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
    console.log('VALUES: ', values)
  };

  async function setNewPassword(newPassword: string) {
    //await dispatch(updateMeTC({ user: {...reqBody, password: newPassword} }))
    await dispatch(updateMyPasswordTC({ user: {...reqBody, password: newPassword} }))
    navigate(`/me/`)
  }

  return (
    <>
      <Container maxWidth={false}>
        <Grid container style={{ paddingTop: '70px', paddingBottom: '50px' }} spacing={3} alignItems="center">
          <Grid item xl={8} md={8} xs={6} style={{ paddingTop: '30px' }}>
            <Button onClick={(e) => navigate(`/`)} color='info' className='addItemButton' startIcon={<KeyboardReturnIcon style={{ color: 'grey' }} fontSize='medium' />}>
              Back to projects
            </Button>
          </Grid>
          <Grid item xl={4} md={4} xs={6}>
            <Button style={{ float: 'right' }}
              color="info"
              variant="contained"
              onClick={updateUser}
              disabled={isSaveButtonDisabled}
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ pt: 3 }}>
          {/* <Box sx={{ minWidth: 1050 }}> */}
          <Box>
            <form
              autoComplete="off"
              noValidate
            >
              <CardHeader
                title={`User data`}
              />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={12} xs={12}>
                    <TextField
                      disabled={true}
                      fullWidth
                      label="User name"
                      name="userName"
                      required
                      variant="outlined"
                      onChange={handleChange}
                      value={values.userName}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-multiple-checkbox-label">Project</InputLabel>
                      <Select
                        disabled={true}
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={myProjects}
                        input={<OutlinedInput label="Project" />}
                        renderValue={(selected) => selected.join(', ')}
                        fullWidth
                      >
                        {projectNames.map((pr) => (
                          <MenuItem key={pr.projectId} value={pr.projectName}>
                            <Checkbox color='info' checked={myProjects.indexOf(pr.projectName) > -1} />
                            <ListItemText primary={pr.projectName} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Name"
                      name="firstName"
                      onChange={handleChange}
                      required
                      value={values.firstName}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Last name"
                      name="lastName"
                      onChange={handleChange}
                      required
                      value={values.lastName}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      onChange={handleChange}
                      required
                      value={values.email}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Description"
                      name="description"
                      onChange={handleChange}
                      required
                      value={values.description}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </form>
            <CardHeader
            // title={`Set new password`}
            />
            <Divider />
            <PasswordSettings span='none' setNewPassword={setNewPassword} />
          </Box>
        </Box>
      </Container>
    </>
  );
}
